import template from './attachmentsList.template.html';

export default {
  template,
  bindings: {
    attachments: '<',
    accounts: '<',
    contacts: '<',
    partners: '<',
    labels: '<',
    showsInAll: '<',
    isCombinePdfSelected: '<',
    onRequestSignature: '&',
    onShareClient: '&',
    onSharePartner: '&',
    onLock: '&',
    onPin: '&',
    onDownload: '&',
    onDownloadPdf: '&',
    onRename: '&',
    onRedactTfn: '&',
    onPreview: '&',
    onLabelsSelect: '&',
    onDelete: '&',
    onChange: '&',
    onReady: '&'
  },
  controller: class controller {
    constructor($rootScope, listServiceNew) {
      'ngInject';

      const ctrl = this;
      ctrl.natural = $rootScope.natural;
      ctrl.list = new listServiceNew.List();
      ctrl.list.clear();

      ctrl.initialize = ({ isFirst }) => {
        ctrl.currentTimeZone = $rootScope.CurrentTimeZone();
        ctrl.currentLocale = $rootScope.CurrentLocale();
        ctrl.contacts = ctrl.contacts || [];
        ctrl.partners = ctrl.partners || [];
        ctrl.attachments = ctrl.attachments || [];
        ctrl.showsInAll = ctrl.showsInAll || false;
        ctrl.isCombinePdfSelected = ctrl.isCombinePdfSelected || false;
        ctrl.list.setData(ctrl.attachments);
        if (isFirst) {
          ctrl.list.setOrderBy('getDateSort()');
          ctrl.list.setOrderBy('getDateSort()');
        }
        ctrl.onReady({ list: ctrl.list });
      };

      ctrl.select = (data) => {
        if (_.isArray(data)) {
          const filteredData = ctrl.isCombinePdfSelected
            ? _.filter(
                data || [],
                (d) => d?.getFileExtension()?.toLowerCase() === 'pdf' && !d?.isLocked
              )
            : _.filter(data || [], (d) => !d?.isLocked);
          if (filteredData?.length) {
            const isSelected = ctrl.list.setSelected(filteredData);
            ctrl.onChange({ list: ctrl.list, data: filteredData, isSelected });
          }
        } else {
          const isDataValid = ctrl.isCombinePdfSelected
            ? data?.getFileExtension()?.toLowerCase() === 'pdf' && !data?.isLocked
            : !data?.isLocked;
          if (isDataValid) {
            const isSelected = ctrl.list.setSelected(data);
            ctrl.onChange({ list: ctrl.list, data, isSelected });
          }
        }
      };

      ctrl.attachmentRequestSignature = ($event, data, type, isNonEmbedded) => {
        ctrl.onRequestSignature({ event: $event, data, type, isNonEmbedded });
      };

      ctrl.attachmentShareClient = ($event, data) => {
        ctrl.onShareClient({ event: $event, data });
      };

      ctrl.attachmentSharePartner = ($event, data) => {
        ctrl.onSharePartner({ event: $event, data });
      };

      ctrl.attachmentLock = ($event, data) => {
        ctrl.onLock({ event: $event, data });
      };

      ctrl.attachmentPin = ($event, data) => {
        ctrl.onPin({ event: $event, data });
      };

      ctrl.attachmentDownload = ($event, data) => {
        ctrl.onDownload({ event: $event, data });
      };

      ctrl.attachmentDownloadPdf = ($event, data) => {
        ctrl.onDownloadPdf({ event: $event, data });
      };

      ctrl.attachmentRename = ($event, data) => {
        ctrl.onRename({ event: $event, data });
      };

      ctrl.attachmentRedactTFN = ($event, data) => {
        ctrl.onRedactTfn({ event: $event, data });
      };

      ctrl.attachmentPreview = ($event, data) => {
        ctrl.onPreview({ event: $event, data });
      };

      ctrl.attachmentLabelsSelect = ($event, data) => {
        ctrl.onLabelsSelect({ event: $event, data });
      };

      ctrl.attachmentDelete = ($event, data) => {
        ctrl.onDelete({ event: $event, data });
      };

      ctrl.areAllItemsSelected = () => {
        if (ctrl.attachments.length) {
          return _.every(ctrl.attachments, (a) => a.isSelected);
        }
        return false;
      };

      ctrl.$onInit = () => {
        ctrl.initialize({ isFirst: true });
      };

      ctrl.$onChanges = (changes) => {
        if (
          (!_.isEmpty(changes?.attachments?.previousValue) &&
            changes?.attachments?.currentValue) ||
          (!_.isEmpty(changes?.isCombinePdfSelected?.previousValue) &&
            changes?.isCombinePdfSelected?.currentValue)
        ) {
          ctrl.initialize({ isFirst: false });
        }
      };
    }
  }
};
